import React from 'react';
import { useSelector } from 'react-redux';
import { IRootState } from '@state/reducers/Reducers';
import PgAvailabilityComponent from './PgAvailabilityComponent';

const PgAvailabilityBanner: React.FC = () => {
  const { periodLabel, totalAvailablePgs, totalSubscriptionPgs, unavailablePgs, isMultiCountry } = useSelector(
    (state: IRootState) => state.availabilityPg,
  );

  return (
    <PgAvailabilityComponent
      periodLabel={periodLabel}
      totalAvailablePgs={totalAvailablePgs}
      totalSubscriptionPgs={totalSubscriptionPgs}
      unavailablePgs={unavailablePgs}
      isMultiCountry={isMultiCountry}
    />
  );
};

export default PgAvailabilityBanner;
